import React, { useState, useEffect } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { RegistrationForm } from "@/components/RegistrationForm";

export const openBooking = () => window.dispatchEvent(new Event("open-booking"));

export const BookingDialog = () => {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const h = () => setOpen(true);
    window.addEventListener("open-booking", h);
    return () => window.removeEventListener("open-booking", h);
  }, []);
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="bg-stone-800 border-stone-700 text-white max-w-lg max-h-[92vh] overflow-y-auto rounded-2xl [&>button]:text-stone-300" data-testid="booking-dialog">
        <DialogHeader className="text-left">
          <DialogTitle className="text-xl font-bold text-white">Book a Consultation</DialogTitle>
          <DialogDescription className="text-sm text-stone-400">Complete your details below. You will be directed to our secure payment page.</DialogDescription>
        </DialogHeader>
        <RegistrationForm idPrefix="book" />
      </DialogContent>
    </Dialog>
  );
};
